import React, { useEffect } from "react";
import { PlanGlance } from "@/components/DayTeams.jsx";
import { HuntWeather } from "@/components/HuntDay.jsx";
import { FREEZER, LUNCH, OTHER_MORNINGS } from "@/content/huntBoard.js";
import { HUNT_SUPPERS } from "@/content/huntMeals.js";
import { HUNT_DAYS } from "@/lib/dayLabels.js";
import { stayState, supperIndexForDate } from "@/lib/huntDates.js";

const DAYS = HUNT_DAYS;

function huntDayLine(iso) {
  const number = Number(iso.slice(8));
  if (iso === "2026-10-02") return "Jour d’arrivée";
  if (number >= 3 && number <= 8) return `Jour ${number - 2} de la chasse`;
  if (iso === "2026-10-09") return "Dernier jour de chasse";
  if (iso === "2026-10-10") return "Retour";
  return "";
}

export function DaySheet({ day, anchor, onSelect, onOpen, tasks, myHunter, hunters }) {
  const mark = stayState(day, anchor);
  const supperIndex = supperIndexForDate(day);
  const supper = supperIndex >= 0 ? HUNT_SUPPERS[supperIndex] : null;
  const mine = tasks.filter((task) => task.assignee_id === myHunter?.id && task.status !== "done");
  useEffect(() => {
    const strip = document.querySelector("[data-testid=day-strip]");
    const tab = document.querySelector(`[data-testid=day-${day}]`);
    if (!strip || !tab) return;
    const left = tab.offsetLeft - (strip.clientWidth - tab.clientWidth) / 2;
    strip.scrollLeft = Math.max(0, left);
  }, [day]);
  return (
    <div className="og-daysheet" data-testid="day-sheet">
      <div className="og-daytabs" data-testid="day-strip" role="tablist">
        {DAYS.map(([iso, label]) => {
          const state = stayState(iso, anchor);
          return (
            <button
              key={iso}
              type="button"
              role="tab"
              className={`og-daytabs__day is-${state}${iso === day ? " is-on" : ""}`}
              data-testid={`day-${iso}`}
              data-state={state}
              aria-selected={iso === day}
              onClick={() => onSelect(iso)}
            >
              {label}
            </button>
          );
        })}
      </div>
      <p className="og-dayhint" data-testid="day-hunt-index">{huntDayLine(day)}</p>
      {mark === "past" ? <p data-testid="day-journal">Journée passée. Le résumé reste consultable.</p> : null}
      {mark === "future" ? <p data-testid="day-future">Cette journée n’est pas encore commencée.</p> : null}
      <div className="og-daygrid">
        <section>
          <h3>Conditions</h3>
          <HuntWeather day={day} />
        </section>
        <section>
          <h3>Plan du jour</h3>
          <PlanGlance day={day} hunters={hunters} onOpen={() => onOpen("organize")} />
        </section>
        <section data-testid="meals-day">
          <h3>Repas</h3>
          <p>Lunch — {LUNCH}</p>
          <p>{supper ? `Souper — ${supper.who} · ${supper.dish}` : "Souper — pas confirmé"}</p>
          <p>{FREEZER}</p>
          {day === "2026-10-02" ? null : <p>Déjeuner — {OTHER_MORNINGS}</p>}
        </section>
        <section>
          <h3>Actions</h3>
          {mine.length ? (
            <ul>{mine.slice(0, 4).map((task) => <li key={task.id}>{task.title}</li>)}</ul>
          ) : <p>Aucune tâche ouverte pour cette fiche.</p>}
          <p>Observations et nouveaux points : les boutons de la journée.</p>
        </section>
      </div>
      <div className="og-now__actions og-daysheet__actions" data-testid="day-actions">
        <button type="button" className="og-btn" data-testid="action-terrain" onClick={() => onOpen("territory-read")}><span className="og-act__full">Lire le territoire</span><span className="og-act__short">Territoire</span></button>
        <button type="button" className="og-btn" data-testid="action-observation" onClick={() => onOpen("observation")}><span className="og-act__full">Observation du jour</span><span className="og-act__short">Observation</span></button>
        <button type="button" className="og-btn" data-testid="action-return" onClick={() => onOpen("return")}><span className="og-act__full">Retour au chalet</span><span className="og-act__short">Retour chalet</span></button>
        <button type="button" className="og-btn" data-testid="action-harvest" onClick={() => onOpen("harvest")}><span className="og-act__full">Orignal abattu</span><span className="og-act__short">Orignal abattu</span></button>
        <button type="button" className="og-btn" data-testid="action-nordquest" onClick={() => onOpen("nordquest-drop")}><span className="og-act__full">NordQuest / nouveaux points</span><span className="og-act__short">NordQuest</span></button>
        {day >= "2026-10-10" ? <button type="button" className="og-btn" onClick={() => onOpen("expenses")}>Bilan financier</button> : null}
      </div>
    </div>
  );
}
